import { useMutation } from '@tanstack/react-query';
import {
  ReentryAnalysisRequestSchema,
  TransferAnalysisRequestSchema,
  type ReentryAnalysisResponse,
  type TransferAnalysisResponse,
} from '@trajectory/contracts';
import type { z } from 'zod';
import { apiFetch } from '@/lib/api';

/** See the matching comment in `useMissions.ts` — `z.input` keeps defaulted fields optional for callers. */
type TransferAnalysisInput = z.input<typeof TransferAnalysisRequestSchema>;
type ReentryAnalysisInput = z.input<typeof ReentryAnalysisRequestSchema>;

/**
 * Both `/analyze/*` routes are stateless, so these are plain mutations rather
 * than cached queries — nothing is persisted, and re-computing on every
 * "Compute" click is exactly what the route is for (see the module doc on
 * `apps/api/src/routes/analyze.ts`).
 */
export function useTransferAnalysis() {
  return useMutation({
    mutationFn: (body: TransferAnalysisInput) =>
      apiFetch<TransferAnalysisResponse>('/analyze/transfer', { method: 'POST', body: JSON.stringify(body) }),
  });
}

export function useReentryAnalysis() {
  return useMutation({
    mutationFn: (body: ReentryAnalysisInput) =>
      apiFetch<ReentryAnalysisResponse>('/analyze/reentry', { method: 'POST', body: JSON.stringify(body) }),
  });
}
